import "./ProductCard.css";

function ProductCard({ product }) {
  return (
    <div className="card">
      <img
        src={product.image}
        alt={product.name}
        className="card-image"
      />

      <h3 className="card-heading">{product.name}</h3>
      <p className="card-para">{product.description}</p>
      <span>{product.category}</span>

      {/* Get Price Button */}
      <a href="#contact" className="price-btn">
        Get Product Price
      </a>
    </div>
  );
}

export default ProductCard;
